define.alias("ember-composable-helpers/helpers/has-next", "preview-grid/helpers/has-next");